import saveAs from 'file-saver';
import { MESSAGE_TYPES } from '@sv-support-sdk/utils/src/constants/chatMessages';
import { divideMessageAndReply, withoutHTML } from '@sv-support-sdk/utils/src/helpers/chatMessage';
import {
  IAttachment,
  IMessage,
  IMessageAction,
} from '@sv-support-sdk/chat-shared-types/src/common/messages';

import { $l } from '../locales';

export const download = (filename: string, text: string) => {
  const blob = new Blob([text], { type: 'text/plain;charset=utf-8' });

  saveAs(blob, filename);
};

const templateForAttachments = (attachments: IAttachment[]) =>
  attachments ? attachments.map((el) => `\n ${$l('FILE')}: ${el.name}`).join('\n') : '';
const gerAuthorName = (el: IMessage) => el.authorName || $l('CHAT_HEADER');

const messageTemplate = (el: IMessage) => {
  const { message, reply } = divideMessageAndReply(withoutHTML(el.message));
  const messageToShow = reply ? `->"${reply}"\n${message}` : message;

  return `${gerAuthorName(el)}: ${el.message && messageToShow.replace(/(\n)/g, '$1    ')}${templateForAttachments(el.attachments)}`;
};

const askTemplate = (el: IMessage) =>
  `${gerAuthorName(el)}: ${$l('CONTACT_INFO')}/${$l('ENTER_YOUR_EMAIL')}`;
const feedbackTemplate = () => $l('PLEASE_RATE');

const notificationTemplate = (el: IMessage) =>
  `${gerAuthorName(el)}: ${el.title || ''} ${el.message || ''}`;

const actionsTemplate = (el: IMessage) =>
  `actions: ${el.actions?.map((action: IMessageAction) => action.name).join(', ')}`;

export const messagesToSend = (messages: IMessage[]) =>
  messages
    ? messages
        .map((el) => {
          switch (el.type) {
            case MESSAGE_TYPES.OPEN:
            case MESSAGE_TYPES.MESSAGE:
            case MESSAGE_TYPES.JOIN:
            case MESSAGE_TYPES.TRANSFER:
            case MESSAGE_TYPES.ATTACHMENT:
              return messageTemplate(el);
            case MESSAGE_TYPES.DIVIDER:
              return `---------------${el.message}-----------------`;
            case MESSAGE_TYPES.ASK_EMAIL:
              return askTemplate(el);
            case MESSAGE_TYPES.FEEDBACK:
              return feedbackTemplate();
            case MESSAGE_TYPES.NOTIFICATION:
              return notificationTemplate(el);
            case MESSAGE_TYPES.QUICK_ACTIONS:
              return actionsTemplate(el);
            default:
              return '';
          }
        })
        .join('\n')
    : '';
